module.exports = __webpack_public_path__ + "media/images/logo_h-40bef467b57c9b730c1ecad548445218.png";